import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Text, TextDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getText(id: string): Observable<Text> {
        return this.httpClient.get<TextDto>(`library/texts/${id}`).pipe(mapDto((data) => new Text(data)));
    }
}
